import {UiState,SetPropertyAction} from '../types/types'
import {actionTypes} from '../types/enums'

const initialUiState:UiState = {
    MAIN_CONTAINER_IsLoading: false,
    MAIN_CONTAINER_IsVisible: false,
    MAIN_CONTAINER_HasErrored: false,
    MAIN_CONTAINER_HasAccess: true,
    SAVE_REVISIONS_IsLoading: false,
    TRANSFER_DOCUMENTS_IsLoading: false,
  };

export const uiState = (state:UiState = initialUiState, action:SetPropertyAction):UiState => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.SET_LOADING:
            return Object.assign({}, state, {
                // sets the loading boolean at this scope
                [`${payload.scope}_IsLoading`]: payload.value,
            });
        case actionTypes.SET_VISIBLE:
            return Object.assign({}, state, {
                // sets the loading boolean at this scope
                [`${payload.scope}_IsVisible`]: payload.value,
            });
        case actionTypes.SET_ERRORED:
            return Object.assign({}, state, {
                // sets the loading boolean at this scope
                [`${payload.scope}_HasErrored`]: payload.value,
            });
        case actionTypes.HAS_ACCESS:
            return Object.assign({}, state, {
                // sets the loading boolean at this scope
                [`${payload.scope}_HasAccess`]: payload.value,
            });
        //special case for toggle 
        case actionTypes.VISIBLE_TOGGLE:
            return Object.assign({}, state, {
                // sets the loading boolean at this scope
                [`${payload.scope}_IsVisible`]: !state[`${payload.scope}_IsVisible`],
        });
        default:
            return state;
    }
}